import React from 'react';

const RoadmapSection = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-5xl mx-auto text-center">

        <h2 className="text-4xl font-bold mb-6">Roadmap</h2>
        <p className="text-gray-400 text-lg mb-12">
          Building the future of orbital intelligence
        </p>

        <div className="space-y-6 text-left">

          <div className="bg-dark-800 p-6 rounded-lg border border-gray-700">
            <p className="text-green-400 font-semibold mb-2">✓ Completed</p>
            <ul className="space-y-2 text-gray-300">
              <li>Orbital Transfer Calculator</li>
              <li>Interactive 3D Visualization</li>
              <li>Public API Access</li>
            </ul>
          </div>

          <div className="bg-dark-800 p-6 rounded-lg border border-primary-500">
            <p className="text-primary-400 font-semibold mb-2">→ Coming Next</p>
            <ul className="space-y-2 text-gray-300">
              <li>Multi-body gravity modeling</li>
              <li>Interplanetary transfer support</li>
              <li>AI-assisted maneuver optimization</li>
              <li>Autonomous mission planning engine</li>
              <li>Large-scale orbital simulation dataset</li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;